import { mobileMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import agentBg from '@propertypal/shared/src/resources/bg/find-agents-bg.jpg';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';
import { BREAKPOINT } from '../search/HomeSearchBar.style';

export const Container = styled.div<{ $tall?: boolean }>`
  background-image: url(${agentBg.src});
  background-size: cover;
  background-position: center;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;

  @media (${tabletMax}) {
    height: auto;
  }

  ${(props) =>
    props.$tall &&
    `
    height: 75vh;
  `}
`;

export const Content = styled.div`
  width: 100%;
  max-width: 800px;

  @media (max-width: ${BREAKPOINT}) {
    padding-bottom: 60px;
  }
`;

export const TabBar = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 15px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (${tabletMax}) {
    overflow-y: scroll;
  }
`;

export const TabItem = styled.button<{ $active: boolean }>`
  margin: 0 15px;
  color: ${(props) => props.theme.white};
  font-size: 20px;
  font-weight: 600;
  padding: 6px 0;
  white-space: nowrap;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.8);

  ${(props) =>
    props.$active &&
    `
    padding: 6px 0 2px;
    border-bottom: 4px solid ${props.theme.primary};
  `}
`;

export const Title = styled.h1`
  color: ${(props) => props.theme.white};
  font-size: 32px;
  text-align: center;
  margin-bottom: 10px;
  font-family: ${platform.headingFont};
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.8);

  @media (${tabletMax}) {
    padding: 0 30px;
  }

  @media (${mobileMax}) {
    padding: 0 10px;
  }
`;

export const SubTitle = styled.h2`
  color: ${(props) => props.theme.white};
  font-size: 24px;
  font-weight: normal;
  text-align: center;
  margin-bottom: 30px;
  padding: 0 30px;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.8);

  @media (${tabletMax}) {
    font-size: 20px;
    padding: 0;
  }
`;
